module.exports = __webpack_public_path__ + "static/media/spacex.6fb731d6.jpeg";